import Resource from './Resource.js';
import moment from 'moment';

var SubstudyResource = new Resource({baseUrl: '/api/substudies', 'dates': []});

SubstudyResource.participants = {
	all: function (substudyId) {
		return axios.get('/api/substudies/'+substudyId+'/participants').then(function (response) {
			var parts = Object.values(response.data).map(function (i) {
				if (i.last_exam) {
					i.last_exam.completion_date = (i.last_exam.completion_date) ? moment(i.last_exam.completion_date, 'YYYY-MM-DD HH:mm:ss') : null;
				}
				if (i.upcoming_task) {
					i.upcoming_task.date_due = (i.upcoming_task.date_due) ? moment(i.upcoming_task.date_due, 'YYYY-MM-DD HH:mm:ss') : null;
				}
				return i;
			});
			return response;
		});
	},
	find: function (substudyId, id) {
		return axios.get('/api/substudies/'+substudyId+'/participants/'+id)
			.then(function (response) {
				response.data.last_reviewed_at = (response.data.last_reviewed_at) ? moment(response.data.last_reviewed_at, 'YYYY-MM-DD') : null;
				if (response.data.last_exam) {
					response.data.last_exam.completion_date = (response.data.last_exam.completion_date) ? moment(response.data.last_exam.completion_date, 'YYYY-MM-DD HH:mm:ss') : null;
				}
				if (response.data.upcoming_task) {
					response.data.upcoming_task.date_due = (response.data.upcoming_task.date_due) ? moment(response.data.upcoming_task.date_due, 'YYYY-MM-DD HH:mm:ss') : null;
				}
				return response;
			}.bind(this))
			.catch( function (error) {
				console.error(error);
			});
	},
	updateParticipantInfo: function (substudy, participant, data) {
		return axios.put('/api/substudies/'+substudy.id+'/participants/'+participant.id, data)
			.then(function (response) {
				return this.find(substudy.id, participant.id)
			}.bind(this))
			.catch( function (error) {
				alert('There was a problem updating the participant(s) substudy status information');
			});
	},
	updateParticipants: function (substudy, data) {
		return axios.put('/api/substudies/'+substudy.id+'/update-participants', data);
	},
	cancelUpcomingTask: function (substudyId, participant) {
		return axios.put('/api/tasks/'+participant.upcoming_task.id, {
			task_status_id: 5
		}).then(function (response) {
			return this.find(substudyId, participant.id);
		}.bind(this))
		.catch(function (error) {
			alert('There was a problem canceling the upcoming task');
		});
	},
	assignParticipant: function (substudy, participant) {
		return axios.post('/api/substudies/'+substudy.id+'/participants/'+participant.id)
					.then(function (response) {
						return response.data;
					}.bind(this))
					.catch(function (error) {
						alert('There was a problem adding '+participant.full_name+' to '+substudy.name);
					})
	},
	updateTaskVisitWindow: function (substudyId, participant, visitWindowId) {
		return axios.put(
			'/api/tasks/' + participant.upcoming_task.id, 
			{
				visit_window_id: visitWindowId
			}
		).then(response => this.find(substudyId, participant.id))
	},
}

export default SubstudyResource;